import { GeneralSetting } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import { StyleColumn } from '@components/styles'
import useWindowSize from '@hooks/useWindow'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const RefundPolicy = () => {
  const { data } = useSelector((state: any) => state.refundPolicy)

  const fetchData = async () => {
    await GeneralSetting.getByKey('refundPolicy', 'refundPolicy')
  }

  const navigate = useNavigate()

  const { width } = useWindowSize()
  const isPhoneScreen = width < 1024
  useEffect(() => {
    if (!data?.id) {
      fetchData()
    }
  }, [])

  return (
    <>
      <BackNavigation
        title="Refund Policy"
        onClick={() => {
          if (isPhoneScreen) {
            navigate('/books/account')
          } else {
            navigate(-1)
          }
        }}
      />

      <StyleColumn
        dangerouslySetInnerHTML={{ __html: data?.value }}
        customStyle={{ padding: 12 }}
      />
    </>
  )
}

export default RefundPolicy
